<template>
  <div
    :class="containerClass"
    v-show="stripeVisible"
    transition="fade"
    @click="stripeClicked()"
  >
    <div v-html="body"></div>
    <div class="link-caret-icon" v-if="caretIcon">
      <svg><use :xlink:href="caretIcon" /></svg>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import countryCode from '../../../analytics/country-code';

export default {
  props: {
    link: {
      type: String,
      required: true
    },
    openLinkInNewTab: {
      type: Boolean,
      required: true
    },
    className: {
      type: String,
      default: 'default'
    },
    caretIcon: {
      type: String
    },
    countryCode: {
      type: String,
      required: true
    },
    urlKey: {
      type: String,
      required: true
    },
    enableGaEvent: {
      type: Boolean,
      default: false
    },
    body: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      stripeVisible: false, //set to true to disable fade transition when stripe appears
      showOnUrls: {
        canada: [
          /^\/$/,
          /^\/index-h$/,
          /^\/pricing$/,
          /^\/pricing-b$/,
          /^\/pos-hardware$/,
          /^\/business-types\/retail-pos$/,
          /^\/business-types\/restaurant-pos$/,
          /^\/business-types\/bar-pos$/,
          /^\/business-types\/quick-service-restaurant-pos$/,
          /^\/pos-system$/,
          /^\/pos\/features$/,
          /^\/pos-software$/
        ],
        all: [/.*/]
      }
    };
  },
  computed: {
    containerClass() {
      return `header-country header-country--${this.className}`;
    }
  },
  methods: {
    checkUrlGroup(group) {
      for (let i = 0; i < group.length; i++) {
        if (group[i].test(window.location.pathname)) {
          return true;
        }
      }
      return false;
    },
    stripeClicked() {
      if (this.enableGaEvent) {
        // remove html tags and entities inside body
        const bannerText = this.body
          .replace(/<[^>]*>/g, '')
          .replace(/&nbsp;/g, ' ');
        dataLayer.push({ event: 'banner', bannerAction: 'Click', bannerText });
      }
      if (this.openLinkInNewTab) {
        window.open(this.link, '_blank');
      } else {
        window.location.href = this.link;
      }
    }
  },

  mounted() {
    if (!this.checkUrlGroup(this.showOnUrls[this.urlKey])) return;

    //wait for country code before showing promo
    countryCode.listenForCountryCode((countryCode) => {
      if (this.countryCode !== countryCode) {
        return;
      }
      const TIME_DELAY = $(window).width() < 768 ? 0 : 1500; // No delay on mobile
      setTimeout(() => {
        this.stripeVisible = true;
      }, TIME_DELAY);
    });
  }
};
</script>
